import { observable, action } from "mobx";
import { Grupo } from "../../../../services";
import { error, success } from "../../../../utils/MensagemUtil";
import { validarCamposObrigatorios } from "../../../../utils/Validate";

class GrupoStore {
  @observable
  grupos = [];

  @observable
  grupo = {
    id: null,
    nome: "",
    descricao: ""
  };

  @observable
  criterios = {};

  @observable
  paginacao = {};

  @observable
  fetching = false;

  @action.bound
  async filtrar() {
    this.fetching = true;

    try {
      const result = await Grupo.consultar(this.criterios);
      if (result && result.erro) {
        this.grupos = [];
        this.paginacao = {};
        return error(result.erro);
      }

      this.grupos = [].concat(result.data);
      this.paginacao = result.paging;
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  paginar = target => {
    this.criterios = { pagina: target.page, limite: target.limit };

    this.filtrar();
  };

  @action.bound
  async remover(id) {
    this.fetching = true;

    try {
      const result = await Grupo.excluir(id);
      if (result.erro) {
        return error(result.erro);
      }

      success("Grupo excluído com sucesso.");

      this.filtrar();
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async cadastrar(history) {
    try {
      this.fetching = true;

      const erros = this.validarCadastro(this.grupo);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Grupo.cadastrar(this.grupo);
      if (result.erro) {
        return error(result.erro);
      }

      success("Grupo cadastrado com sucesso.");

      history.push("/cadastros/grupos");
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async alterar(history) {
    try {
      this.fetching = true;

      const erros = this.validarCadastro(this.grupo);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Grupo.alterar(this.grupo);
      if (result.erro) {
        return error(result.erro);
      }

      success("Grupo alterado com sucesso.");
      history.push("/cadastros/grupos");
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async buscar(id) {
    try {
      this.fetching = true;

      const result = await Grupo.buscar(id);
      if (result && result.erro) {
        this.grupo = {};
        return error(result.erro);
      }

      this.grupo = result;
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  handleChange = ({ target }) => {
    const { name, value } = target;

    this.grupo[name] = value;
  };

  validarCadastro = registro => {
    const erros = validarCamposObrigatorios()
      .addSeNuloOuVazio("Nome", registro.nome)
      .build();

    return erros;
  };
}

export default new GrupoStore();



// WEBPACK FOOTER //
// ./src/views/cadastros/grupos/stores/GrupoStore.js